if (!customElements.get("product-form")) {
    customElements.define(
        "product-form",
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector("form");
                this.form.querySelector("[name=id]").disabled = false;
                this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
                this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
                this.submitButton = this.querySelector('[type="submit"]');
                if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");
            }

            onSubmitHandler(evt) {
                evt.preventDefault();
                if (this.submitButton.getAttribute("aria-disabled") === "true") return;

                this.handleErrorMessage();

                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.classList.add("loading");
                this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

                const config = fetchConfig("javascript");
                config.headers["X-Requested-With"] = "XMLHttpRequest";
                delete config.headers["Content-Type"];

                const formData = new FormData(this.form);
                if (this.cart) {
                    formData.append(
                        "sections",
                        this.cart.getSectionsToRender().map((section) => section.id)
                    );
                    formData.append("sections_url", window.location.pathname);
                    this.cart.setActiveElement(document.activeElement);
                }
                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            this.handleErrorMessage(response.description);

                            const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
                            if (!soldOutMessage) return;
                            this.submitButton.setAttribute("aria-disabled", true);
                            this.submitButton.querySelector("span").classList.add("hidden");
                            soldOutMessage.classList.remove("hidden");
                            this.error = true;
                            return;
                        } else if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        }

                        this.error = false;
                        const quickAddModal = this.closest("quick-add-modal");
                        if (quickAddModal) {
                            document.body.addEventListener(
                                "modalClosed",
                                () => {
                                    setTimeout(() => {
                                        this.cart.renderContents(response);
                                    });
                                },
                                { once: true }
                            );
                            quickAddModal.hide(true);
                        } else {
                            this.cart.renderContents(response);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.submitButton.classList.remove("loading");
                        if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
                        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
                        setTimeout(() => {
                            if (this.cart) this.cart.close();
                        }, Number(this.cart.dataset.timeout));
                    });
            }

            handleErrorMessage(errorMessage = false) {
                this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
                if (!this.errorMessageWrapper) return;
                this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

                this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }
        }
    );
}

if (!customElements.get("slider-product")) {
    customElements.define(
        "slider-product",
        class ProductSlide extends HTMLElement {
            constructor() {
                super();
                this.main = this.querySelector(".js-main-media");
                this.thumb = this.querySelector(".js-thumb-media") || null;
                this.nextBtn = this.querySelector(".slider-button--next") || null;
                this.prevBtn = this.querySelector(".slider-button--prev") || null;
                this.pagi = this.querySelector(".swiper-pagination") || null;
                // this.thumbViews = Number(this.dataset.thumbViews) || 5;
                this.thumbViews = "auto";
                this.loop = this.hasAttribute("data-loop");
                this.zoom = this.hasAttribute("data-zoom");
                this.autoHeight = this.hasAttribute("data-auto-height");
                this.autoPlay = this.hasAttribute("data-auto-play")
                    ? {
                          delay: Number(this.dataset.time ? this.dataset.time : 3) * 1000,
                      }
                    : false;
                    this.main && this.initSlider();
            }
            connectedCallback() {
            }
            initSlider() {
                if (this.thumb) {
                    this.swiperThumb = new Swiper(this.thumb, {
                        // loop: true,
                        spaceBetween: 12,
                        slidesPerView: this.thumbViews,
                        watchOverflow: true,
                        centerInsufficientSlides: true,
                        // freeMode: true,
                        // watchSlidesProgress: true,
                    });
                }

                let optionMain = {
                    loop: this.loop,
                    spaceBetween: 10,
                    autoplay: this.autoPlay,
                    autoHeight: this.autoHeight,
                    zoom: this.zoom,
                    on: {
                        slideChange: (e) => {
                            window.pauseAllMedia();
                        },
                        init: function (e) {
                            if (this.el.querySelector(".swiper-slide-active video")) {
                                this.el.querySelector(".swiper-slide-active video").play();
                            }
                        },
                    },
                };

                if (this.pagi) {
                    optionMain.pagination = {
                        el: this.pagi,
                        clickable: true,
                        dynamicBullets: true,
                        dynamicMainBullets: 3,
                    };
                }
                if (this.nextBtn && this.prevBtn) {
                    optionMain.navigation = {
                        nextEl: this.nextBtn,
                        prevEl: this.prevBtn,
                    };
                }
                if (this.swiperThumb) {
                    optionMain.thumbs = {
                        swiper: this.swiperThumb,
                    };
                }

                this.swiperMain = new Swiper(this.main, optionMain);

                function playPauseVideo(swiper, control) {
                    let currentSlide, video;
                    currentSlide = swiper.querySelector(".swiper-slide-active");
                    video = currentSlide && currentSlide.querySelector("video");

                    if (video) {
                        if (control == "play") {
                            video.play();
                        } else {
                            video.pause();
                        }
                    }
                }

                this.swiperMain.on("slideChange", function (e) {
                    playPauseVideo(this.$el[0], "pause");
                });
                this.swiperMain.on("slideChangeTransitionEnd", function (e) {
                    playPauseVideo(this.$el[0], "play");
                });
            }
            slideTo(index) {
                let checkIndex = Number(index) || 0;
                this.swiperMain.slideTo(checkIndex + 1, 0);
            }
        }
    );
}

/*document.addEventListener("DOMContentLoaded", () => {
    console.log('DOMContentLoaded');
    var counter = 0;
    var checkSubscriptionButton = setInterval(function(){
        counter++;
        if ( document.querySelector('[name="purchase_type"]') != null ) {
            const purchaseType = document.querySelector('[name="purchase_type"]:checked');
            const purchaseTypeWrapper = purchaseType.closest('.rc_block__type');
            const purchaseTypePrice = purchaseTypeWrapper.querySelector('.rc_price').innerText;
            const atcLabel = 'Add to Bag' + '  &nbsp;  &nbsp;| &nbsp;  &nbsp;' + purchaseTypePrice;
            if ( document.querySelector('.product__info-wrapper .product-form__submit > span') != null && purchaseTypePrice != '' ) {
                document.querySelector('.product__info-wrapper .product-form__submit > span').innerHTML = atcLabel;
                clearInterval(checkSubscriptionButton);
            }
        }
        if (counter> 50) {
            clearInterval(checkSubscriptionButton);
        }
    },100);

    document.addEventListener("change", function(e){
        console.log('change main');
        const target = e.target;
            if(target.getAttribute('name') == 'purchase_type'){
            const purchaseType = document.querySelector('[name="purchase_type"]:checked');
            const purchaseTypeWrapper = purchaseType.closest('.rc_block__type');
            const purchaseTypePrice = purchaseTypeWrapper.querySelector('.rc_price').innerText;
            const atcLabel = 'Add to Bag' + '  &nbsp;  &nbsp;| &nbsp;  &nbsp;' + purchaseTypePrice;
            if ( document.querySelector('.product__info-wrapper .product-form__submit > span') != null && purchaseTypePrice != '' ) {
                document.querySelector('.product__info-wrapper .product-form__submit > span').innerHTML = atcLabel;
            }
        }
        if (target.getAttribute('name').includes('selling_plan_')) {
            console.log('change');
            var purchaseTypeCheck = document.querySelector('.rc-widget input:checked');
            var purchaseTypeWrapperClose = purchaseTypeCheck.closest('.rc_widget__option');
            var purchaseTypePriceCheck = purchaseTypeWrapperClose.querySelector('.rc_widget__price').innerText;
            var atcLabelCheck = 'Add to Bag' + '  &nbsp;  &nbsp;| &nbsp;  &nbsp;' + purchaseTypePriceCheck;
            if ( document.querySelector('.product__info-wrapper .product-form__submit > span') != null && purchaseTypePriceCheck != '' ) {
                document.querySelector('.product__info-wrapper .product-form__submit > span').innerHTML = atcLabelCheck;
            }
        }
    });
});*/
document.addEventListener("DOMContentLoaded", () => {
    console.log('Recharge Widget Script Loaded');

    let counter = 0;

    const interval = setInterval(() => {
        counter++;

        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        if (rechargeWidget && rechargeWidget.shadowRoot) {
            console.log('recharge-subscription-widget');
            const shadow = rechargeWidget.shadowRoot;

            // Attach the change listener *inside* the shadow root only once
      if (!shadow.__listenerAttached) {
        shadow.__listenerAttached = true;
        shadow.addEventListener("change", handleRechargeChange, true);
        console.log("Change listener attached inside shadow root");
      }
       
      // Run initial label update
      setTimeout(() => {
        injectPriceLabel(shadow);         // Label above widget
        injectOrDivider(shadow); 
        updateATCLabel(shadow);
        injectRechargeStyles(shadow)
      },2000);
      clearInterval(interval);
    }

    if (counter > 50) clearInterval(interval);
  }, 200);

  function injectRechargeStyles(shadowRoot){
    if (shadowRoot.querySelector('#recharge-custom-styles')) return; // prevent duplicates
    const style = document.createElement('style');
    style.id = 'recharge-custom-styles';
    style.textContent = `
        .rc-widget__root .rc-purchase-option {
            border-color: #d9dde8;
        }
    `;
    shadowRoot.appendChild(style);
  }

  function updateATCLabel(shadowRoot) {

    const deliveryDropdown = shadowRoot.querySelector('rc-selling-plans');
        if(deliveryDropdown)
            deliveryDropdown.style.display = 'none';
    
 const selectedOption = shadowRoot.querySelector('.rc-purchase-option[rc-selected]');
  
  let price = "";

  if (selectedOption) {
    // Get all `.rc-price` elements globally inside the selectedOption
    const prices = selectedOption.querySelectorAll('.rc-price');
    
    if (prices.length > 1) {
      // Second one is usually discounted
      const discounted = prices[1];
      for (const node of discounted.childNodes) {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.trim();
          if (text.startsWith('$')) {
            price = text;
            break;
          }
        }
      }
    } else if (prices.length === 1) {
      // Fall back to the only one
      const fallback = prices[0];
      for (const node of fallback.childNodes) {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.trim();
          if (text.startsWith('$')) {
            price = text;
            break;
          }
        }
      }
    }
  }
    // const buttonSpan = document.querySelector(".product__info-wrapper .product-form__submit > span");
    // if (price && buttonSpan) {
    //   const label = `Add to Bag&nbsp;&nbsp;|&nbsp;&nbsp;${price}`;
    //   buttonSpan.innerHTML = label;
    // }
  }

  function injectPriceLabel(shadowRoot) {
    const selectionRoot = shadowRoot.querySelector('.rc-selection__root');
    if (!selectionRoot || shadowRoot.querySelector('.custom-price-label')) return;

    const label = document.createElement('div');
    label.textContent = 'Choose your price:';
    label.className = 'custom-price-label';
    label.style.fontWeight = 'normal';
    label.style.fontSize = '14px';
    label.style.marginBottom = '8px';

    selectionRoot.parentElement.insertBefore(label, selectionRoot);
    }

    function injectOrDivider(shadowRoot) {
    const options = shadowRoot.querySelectorAll('.rc-purchase-option');
    if (options.length < 2 || shadowRoot.querySelector('.custom-or-divider')) return;

    const divider = document.createElement('div');
    divider.className = 'custom-or-divider';
    divider.innerHTML = `<div style="text-align:center; margin: 12px 0; position: relative;">
        <hr style="border: none; border-top: 1px solid #ccc;" />
        <span style="position: absolute; top: -10px; left: 50%; background: #fff; padding: 0 10px; transform: translateX(-50%); font-size: 14px; color: #999;">
        OR
        </span>
    </div>`;

    options[0].insertAdjacentElement('afterend', divider);
    }   

  function handleRechargeChange(e) {
    const rechargeWidget = document.querySelector("recharge-subscription-widget");
    if (!rechargeWidget || !rechargeWidget.shadowRoot) return;
    setTimeout(() => {
    updateATCLabel(rechargeWidget.shadowRoot);
    },1000);
  }
});